export default __webpack_public_path__ + "281d3be0d9dc6df33db6bb61bdcb0ffd.png";